import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
const RejectionNoteModal = _ref => {
  let isOpen = _ref.isOpen,
    rejectionNote = _ref.rejectionNote,
    onHide = _ref.onHide;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    toggle: onHide,
    backdrop: "static",
    keyboard: false
  }, /*#__PURE__*/React.createElement(ModalHeader, null, "Report Rejected"), /*#__PURE__*/React.createElement(ModalBody, null, rejectionNote), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    className: "t-button-ok",
    onClick: onHide
  }, "Ok")));
};
RejectionNoteModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  rejectionNote: PropTypes.string.isRequired
};
export default RejectionNoteModal;